export default __webpack_public_path__ + "static/media/drive_large.ad4b5472.png";